import React, {useEffect, useState} from "react";
import {Button, Card, Input, message, Space, Table, Upload} from "antd";
import {TabButtons} from "../ClassAndStudentParts/TabButtons";
import {ButtonAndModal} from "./ButtonAndModal";
import {getHostAddress,getFrontEndAddress} from "../../Tool/UtileFun"
import {UploadOutlined} from "@ant-design/icons";

export function StudentTab(){

    useEffect(
        ()=>{
            findAll()
        },[]
    );

    const findAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/user/findByAllStudent",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify("{}"),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setUser(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchUser=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/user/searchStudentNew",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setUser(data)
                console.log("search-------")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const deleteClass=()=>{
        console.log(classId)
    }

    let classId = ""

    const buttons = () =>{
        return(
            <>
                <Button type="primary" >编辑</Button>
                <Button type="primary" danger onClick={deleteClass}>删除</Button>
            </>
        )
    }


    const [user,setUser]=useState([]);

    const { Search } = Input;

    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '学号',
            dataIndex: 'studentNumber',
            key: 'studentNumber',
        },
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName',
        },
        {
            title: '班级',
            dataIndex: 'className',
            key: 'ClassName',
        },
        {
            title: "电话号码",
            dataIndex: "telNumber",
            key:"telNumber",
        },
        {
            title: '操作',
            key: 'details',
            render: (userInfo) => (
                <>
                    <Space size="middle">
                        <ButtonAndModal props={userInfo}
                                        Event={()=>{
                                            findAll()
                                        }}
                        ></ButtonAndModal>
                    </Space>
                </>
            ),
        },

    ];

    let data = []

    const propsData = {
        name: 'file',
        listType: 'video',
        action: "http://"+getHostAddress()+"/batchImportApi/importStudent",
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload(file) {
            console.log(file.name)
            if (file.size > 1048576*500){
                message.info("上传文件最大支持500MB")
                return false
            }
            let fileName = file.name
            let format = ""
            let realFormat = ""
            for (let i = fileName.length - 1; i >= 0; i--) {
                console.log(fileName[i])
                if (fileName[i] === "."){
                    break
                }
                if (fileName[i] !== "."){
                    format = format + fileName[i]
                }
            }

            for (let i = format.length - 1 ; i >= 0 ; i--) {
                if (format[i] !=="."){
                    realFormat = realFormat + format[i]
                }
            }
            if (realFormat!=="xlsx"){
                message.info("仅支持xlsx格式的视频")
                return false
            }
            return true
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 文件上传成功`);
                findAll()
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 文件上传失败.`);
            }
        },
    };

    return(
        <Card title={"学生管理"}>
            <Search placeholder="输入学生名称搜索"
                    onSearch={value => searchUser(value)}
                    enterButton
                    style={{width:500}}/>
            <Upload {...propsData}>
                <Button icon={<UploadOutlined />}>导入学生</Button>
            </Upload>
            <Table
                columns={columns}
                dataSource={user}
                pagination={{
                    onChange: page => {
                        console.log(page);
                    },
                    pageSize: 5,
                }}
            ></Table>
        </Card>
    )
}
